export default __webpack_public_path__ + "static/media/insurance.0553c400.png";